// NPM Packages
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Typography,
  BottomNavigation,
  BottomNavigationAction,
  Modal,
  Fade,
  Backdrop,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DescriptionIcon from "@material-ui/icons/DescriptionOutlined";
import {
  CropFree as QRIcon,
  ArrowBackIos,
  Call as CallIcon,
  AccountCircle as AccountIcon,
} from "@material-ui/icons";
import Loader from "react-loader";
import QRCode from "qrcode.react";
import store from "store2";

// Components
import DeliveryMap from "../components/DeliveryMap";
import DeliveryDetails from "./DeliveryDetails";
import OfflineComponent from "../components/OfflineComponent";

// helpers
import { apiGet } from "../helpers/api";
import deliveryStatusMapping from "../helpers/deliveryStatusMapping";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "10vh",
    backgroundColor: "#942424",
  },
  toolbar: {
    margin: "0",
    top: "50%",
    transform: "translateY(-50%)",
  },
  bottomNavAction: {
    color: "#fff",
    fontSize: "medium",
  },
  bottomNavActionDisabled: {
    color: "#c57777",
    textShadow: "0 0 32px white",
    fontSize: "medium",
  },
  appBar: {
    height: "10vh",
    backgroundColor: "#942424",
  },
  title: {
    flexGrow: 1,
    fontWeight: "bold",
  },
  back: {
    color: "#fff",
    fontSize: "small",
  },
  mapContainer: {
    height: "80vh",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

function Delivery(props) {
  const classes = useStyles();
  const [delivery, setDelivery] = useState(null);
  const [position, setPosition] = useState(null);
  const [open, setOpen] = useState(false);
  const [openDeliveryDetails, setOpenDeliveryDetails] = useState(false);

  const fetchDelivery = async () => {
    if (delivery) {
      return null;
    }

    try {
      const response = await apiGet(`/deliveries/${props.match.params.uuid}`);
      setDelivery(response.data.data);

      return response.data.data;
    } catch (err) {
      console.log(err.response?.data?.message);
    }
  };

  useEffect(() => {
    fetchDelivery().then((delivery) => {
      if (delivery) {
        if (delivery.riderPosition) {
          setPosition(delivery.riderPosition);
        }

        window.Echo.channel(`delivery.${delivery.id}`).listen(
          ".RiderPositionChanged",
          (event) => {
            setPosition(event.position);
          }
        );
      }
    });
  });

  const callMobile = () => {
    if (delivery?.rider?.mobileNumber) {
      window.location.href = `tel:${delivery?.rider?.mobileNumber}`;
    }
  };

  const user = store.session.get("user");

  return (
    <>
      <OfflineComponent />
      <Loader loaded={!!delivery}>
        <AppBar position="static" className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
            {user && (
              <Link to="/">
                <ArrowBackIos className={classes.back} />
              </Link>
            )}

            <Typography variant="h6" className={classes.title}>
              {`Order # ${delivery?.orderId}`}
            </Typography>
          </Toolbar>
        </AppBar>

        <div className={classes.mapContainer}>
          <DeliveryMap
            googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API}&v=3.exp&libraries=geometry,drawing,places`}
            loadingElement={<div style={{ height: "100%" }} />}
            containerElement={<div style={{ height: "80vh" }} />}
            mapElement={<div style={{ height: "100%" }} />}
            center={{
              lat: delivery?.customerPosition?.latitude,
              lng: delivery?.customerPosition?.longitude,
            }}
            rider={delivery?.rider}
            riderPosition={{
              lat: position?.latitude,
              lng: position?.longitude,
            }}
            storePosition={{
              lat: delivery?.store?.latitude,
              lng: delivery?.store?.longitude,
            }}
            route={
              delivery?.lastDirections?.routes[0]?.overview_polyline?.points
            }
          />
        </div>

        <BottomNavigation showLabels className={classes.root}>
          <BottomNavigationAction
            onClick={callMobile}
            className={
              !delivery?.rider?.mobileNumber
                ? classes.bottomNavActionDisabled
                : classes.bottomNavAction
            }
            disabled={!delivery?.rider?.mobileNumber}
            label="Call Rider"
            icon={<CallIcon />}
          />
          {delivery?.rider?.firstName ? (
            <BottomNavigationAction
              className={classes.bottomNavAction}
              disabled
              label={`${delivery?.rider?.firstName} ${
                delivery?.rider?.lastName || ""
              }`}
              icon={<AccountIcon />}
            />
          ) : (
            <BottomNavigationAction
              className={classes.bottomNavAction}
              onClick={() => setOpen(true)}
              label="Assign Rider"
              icon={<QRIcon />}
            />
          )}
          <BottomNavigationAction
            className={
              delivery?.rider?.firstName
                ? classes.bottomNavAction
                : classes.bottomNavActionDisabled
            }
            onClick={() => setOpenDeliveryDetails(true)}
            label={deliveryStatusMapping[delivery?.status]}
            icon={<DescriptionIcon />}
          />
        </BottomNavigation>

        <Modal
          className={classes.modal}
          open={open}
          onClose={() => setOpen(false)}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open}>
            <div className={classes.paper}>
              <h2 id="transition-modal-title">Scan QR Code</h2>
              <p id="transition-modal-description">
                <QRCode
                  value={`https://delivery-tracker-api.my.hiflyer.ca/api/deliveries/${delivery?.id}`}
                  size={300}
                />
              </p>
            </div>
          </Fade>
        </Modal>

        <Modal
          className={classes.modal}
          open={openDeliveryDetails}
          onClose={() => setOpenDeliveryDetails(false)}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={openDeliveryDetails}>
            <div className={classes.paper}>
              <DeliveryDetails delivery={delivery} />
            </div>
          </Fade>
        </Modal>
      </Loader>
    </>
  );
}

export default Delivery;
